import type { FC } from "react";

import { CaseCompanyPane } from "../../companies/case/CaseCompanyPane";
import { useCaseIde } from "../context/CaseIdeContext";

/** "Company" open in the center pane. */
export const CompanyPane: FC = () => {
  const { individualId } = useCaseIde();
  return <CaseCompanyPane individualId={individualId} />;
};
